import React from 'react';

const Rank =() =>{
    return(
        <div>
            <div className='tc white f2 '>
                {'FaceRecognisation'}
            </div>
            <div className='white f3'>
                {'CONDITION : *Supports Only Single Face included photos*'}
            </div>
        </div>
    );
}

export default Rank;